import { useWhitelabelFeatures } from './whitelabel/useWhitelabelFeatures';

/**
 * Whether the transporter's master-cities catalog backs the city control.
 *
 * Opt-in per tenant via the `ENABLE_PASSENGER_CITY_SELECTOR` feature flag (e.g.
 * Flota Ospina, whose provider requires a city chosen from its master catalog to
 * create the invoicing "tercero"). When on, `useMasterCities` fetches the catalog
 * and the buyer's city select (`AddressFields`, shown only when invoicing) is bound
 * to it. The flag defaults to `false` (`config/defaultFeatures.js`) so other brands
 * are unaffected.
 *
 * The city/address are no longer collected per passenger — they live only in the
 * buyer (comprador) form and only when the buyer chooses to invoice.
 *
 * @returns {boolean} True when the master-cities catalog should back the city control.
 */
function usePassengerCitySelector() {
  const features = useWhitelabelFeatures();
  return Boolean(features.ENABLE_PASSENGER_CITY_SELECTOR);
}

export default usePassengerCitySelector;
